export default __webpack_public_path__ + "static/media/dickcatz09.305fd2ad.png";